<template>
  <div v-if="visible" class="workcenter-context-menu" :style="menuStyle">
    <button v-if="!isViewed" type="button" @click="$emit('mark-read')">Mark as Read</button>
    <button v-else type="button" @click="$emit('mark-unread')">Mark as Un-read</button>
    <button type="button" @click="$emit('open')">Open in New Tab</button>
  </div>
</template>

<script>
export default {
  name: 'WorkcenterContextMenu',
  props: {
    visible: { type: Boolean, default: false },
    isViewed: { type: Boolean, default: false },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 }
  },
  computed: {
    menuStyle() {
      return {
        left: this.x + 'px',
        top: this.y + 'px'
      }
    }
  }
}
</script>
